import TextSubtitle from "apps/website/components/base/Text/TextSubtitle/TextSubtitle";
import TextTitle from "apps/website/components/base/Text/TextTitle/TextTitle";
import TastyMonialsCarousel from "apps/website/components/feature/Carousel/TastyMonialsCarousel/TastyMonialsCarousel";
import {
  tastyMonialsData,
} from "apps/website/components/feature/Carousel/TastyMonialsCarousel/shared/TastyMonialsData";
import Container from "apps/website/components/layout/Container/Container";
import Section from "apps/website/components/layout/Section/Section";
import Spacer from "apps/website/components/layout/Spacer/Spacer";

export default function SectionTastyTestimonials() {
  return (
    <Section component="SectionTastyTestimonials" theme="dark">
      <Container>
        <div className="flex flex-col gap-4 mb-6 md:mb-8 ">
          <TextTitle size={1} align="center" className="uppercase">
            <span className={"bg-brand inline-block transform rotate-2 p-1 text-black items-center"}>Tasty</span>
            <span className="text-white">Monials</span>
          </TextTitle>
          <TextSubtitle size={1} align="center" className="text-white">KatKin devoured. Lives transformed.</TextSubtitle>
          <Spacer size="lg" />
        </div>
        <Container padding="none">
          <TastyMonialsCarousel items={tastyMonialsData} />
        </Container>
      </Container>
    </Section>
  );
}
